// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__vW1SC","cell__header":"Cell_cell__header__0rA7J"};